import { Component, DoCheck } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldProps } from '@ngx-formly/core';
import { PickList } from 'primeng/picklist';

export interface PicklistOption {
  id: string;
  label: string;
}

export interface PicklistFieldProps extends FormlyFieldProps {
  options?: PicklistOption[];
  sourceHeader?: string;
  targetHeader?: string;
  filterPlaceholder?: string;
}

/**
 * Doppia lista (disponibili → selezionati) basata su `p-picklist`, stesso
 * aspetto del preset-editor. Il valore del control è l'array degli `id` selezionati.
 */
@Component({
  selector: 'picklist-field',
  standalone: true,
  imports: [PickList],
  template: `
    <p-picklist
      class="block h-88 w-full"
      dataKey="id"
      filterBy="label"
      styleClass="w-full h-full picklist-fill-height"
      [source]="source"
      [target]="target"
      [showSourceFilter]="true"
      [showTargetFilter]="true"
      [showSourceControls]="false"
      [showTargetControls]="false"
      [sourceFilterPlaceholder]="props.filterPlaceholder ?? ''"
      [targetFilterPlaceholder]="props.filterPlaceholder ?? ''"
      [sourceHeader]="props.sourceHeader ?? ''"
      [targetHeader]="props.targetHeader ?? ''"
      [stripedRows]="true"
      (onMoveToTarget)="sync()"
      (onMoveToSource)="sync()"
      (onMoveAllToTarget)="sync()"
      (onMoveAllToSource)="sync()"
    >
      <ng-template let-item #item>
        <div>{{ item.label }}</div>
      </ng-template>
    </p-picklist>
  `,
})
export class PicklistFieldType
  extends FieldType<FieldTypeConfig<PicklistFieldProps>>
  implements DoCheck
{
  source: PicklistOption[] = [];
  target: PicklistOption[] = [];

  private _key = '';

  ngDoCheck(): void {
    const options = this.props.options ?? [];
    const ids: string[] = this.formControl.value ?? [];
    const key = `${options.map((o) => o.id).join(',')}|${ids.join(',')}`;

    // ⚠️ ricostruisce le liste solo se options/valore cambiano dall'esterno
    // (model caricato in async, copia da altra config…): le mosse dell'utente
    // le gestisce già p-picklist mutando source/target.
    if (key === this._key) return;
    this._key = key;
    this.target = ids
      .map((id) => options.find((o) => o.id === id))
      .filter((o): o is PicklistOption => !!o);
    this.source = options.filter((o) => !ids.includes(o.id));
  }

  sync(): void {
    const ids = this.target.map((o) => o.id);
    this._key = `${(this.props.options ?? []).map((o) => o.id).join(',')}|${ids.join(',')}`;
    this.formControl.setValue(ids);
    this.formControl.markAsDirty();
  }
}
